import { useContext } from "react";
import { SmartContext } from "../../../../../library/Core/SmartContext";
import { Link } from "react-router-dom";
import { getDomainValueForCode } from "../../../../../library/Core/SmartFunctions";

const SelectInstituteOptionLayout = () => {
    const { state } = useContext(SmartContext);
    const model = state.internal.model;

    const selectedInstitute = state?.data?.selectedInstitute;

    const instituteName =
        getDomainValueForCode(
            selectedInstitute?.instituteId,
            "INSTITUTE_DOMAIN",
            state
        ) ?? "";

    const handleClick = (e:any) => {
        e.preventDefault();
        window.location.href = `/alumni/${model.id}/select-institute`;
    }

    return (
        <div className="col-auto">
            <Link
                to={`/alumni/${model.id}/select-institute`}
                className="btn btn-green px-3"
                onClick={handleClick}
            >
                <i className="bi bi-building me-2 position-relative"></i>
                <span>Selected : {instituteName}</span>
            </Link>
        </div>
    );
};

export default SelectInstituteOptionLayout;